var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "make-payment-container" }, [
    _c(
      "div",
      { staticClass: "bill-pay-success-fail", attrs: { id: "top-target" } },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "h2",
          {
            staticClass:
              "gds-display-2 gds-align--text-center gds-space-stack-ml"
          },
          [_vm._v("Oh no!")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bill-pay-fail__description gds-body-large gds-align--text-center gds-space-stack-xl"
          },
          [
            _vm._v(
              "\n      We were unable to process your request at this time. Please try again or contact customer support for assistance at\n      "
            ),
            _c("span", { staticClass: "gds-nobreak" }, [
              _vm._v(_vm._s(_vm.GMPPhoneNumber) + ".")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "bill-pay-success__button-wrap gds-align--text-center gds-space-stack-l"
          },
          [
            _c(
              "button",
              {
                staticClass: "bill-pay-success__button gds-button",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.ReturnToSender("/stop-service")
                  }
                }
              },
              [_vm._v("Done")]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bill-pay-fail__intro-image gds-space-stack-xl" },
      [
        _c("img", {
          staticClass: "my-account__payment-plan-icon",
          attrs: {
            src:
              "/wp-content/themes/gmptwentynineteen/assets/images/pay-fatal-error.svg",
            alt: "unsuccessful payment"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }